import { WL_CONFIG } from 'constants';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding: 24px 0;

  .addresses-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .addresses-title {
    margin: 0 !important;
    font-weight: 600;
  }

  .addresses-empty {
    padding: 48px 24px;
  }

  .addresses-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
  }

  .address-card {
    .address-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    .address-title {
      font-weight: 600;
      font-size: 14px;
    }

    .address-detail {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 8px;
    }

    .address-extra {
      font-size: 13px;
      color: #717679;
      margin-bottom: 4px;
    }

    .address-actions {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;

      .ant-btn-link {
        padding: 0;
        color: ${WL_CONFIG.colors.primary};
      }
    }
  }
`;
